// Sidebar and navigation label constants
// All labels must be lowercase per project convention

export const NAV_LABELS = {
  addTask: "add task",
  search: "search",
  inbox: "inbox",
  next: "next",
  due: "due",
  history: "history",
  settings: "settings",
} as const;

export const SECTION_LABELS = {
  filters: "filters",
  projects: "projects",
  contexts: "contexts",
} as const;
